module.exports = __webpack_public_path__ + "img/ff-landing-pg.8e22babf.jpg";